<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [style]="{ width: '92vw', maxWidth: '1280px', height: '90vh' }"
    [maximizable]="true"
    [closable]="true"
    (onHide)="close(false)"
    header="{{ roleId ? 'Edit Custom Role' : 'Create Custom Role' }}"
    styleClass="custom-role-dialog">

    <p-toast></p-toast>

    <div class="role-builder-container">
        <!-- 1. Basic Details -->
        <div class="builder-section">
            <div class="section-header">
                <h3><i class="pi pi-id-card"></i> 1. Role Details</h3>
                <span class="section-subtitle">Define the basic identity and scope for this custom role.</span>
            </div>
            <div class="form-grid">
                <div class="form-field field-grow">
                    <label for="roleName">Role Name <span class="required">*</span></label>
                    <input id="roleName" pInputText [(ngModel)]="roleName" placeholder="e.g. Customs & Invoicing Specialist" />
                </div>
                <div class="form-field field-grow">
                    <label for="description">Description</label>
                    <input id="description" pInputText [(ngModel)]="description" placeholder="Briefly describe what this role allows..." />
                </div>
                <div class="form-field">
                    <label for="scope">Role Scope</label>
                    <input id="scope" pInputText [(ngModel)]="roleScope" disabled />
                </div>
            </div>
        </div>

        <!-- 2. Multi-Role Stitching -->
        <div class="builder-section">
            <div class="section-header">
                <div class="flex-between">
                    <div>
                        <h3><i class="pi pi-link"></i> 2. Stitch Standard Roles (Baseline Templates)</h3>
                        <span class="section-subtitle">
                            Pick one or multiple standard roles as building blocks. Their permissions are automatically combined into your baseline.
                        </span>
                    </div>
                    <div class="stitch-badge-counter">
                        <span class="counter-highlight">{{ selectedStandardRoleIds.size }}</span> standard roles selected
                        <span class="text-secondary">({{ countFromStitchedRoles }} permissions inherited)</span>
                    </div>
                </div>
            </div>

            <div class="standard-roles-grid">
                <div *ngFor="let standard of standardRoles"
                     class="role-card"
                     [class.selected]="isStandardRoleSelected(standard.roleId)"
                     (click)="toggleStandardRole(standard)">
                    <div class="role-card-header">
                        <div class="role-card-title">
                            <i class="pi" [ngClass]="isStandardRoleSelected(standard.roleId) ? 'pi-check-circle text-primary' : 'pi-circle'"></i>
                            <strong>{{ standard.roleName }}</strong>
                        </div>
                        <p-tag [value]="standard.permissionCount + ' perms'" severity="info"></p-tag>
                    </div>
                    <p class="role-card-desc">{{ standard.description || 'Predefined system role template.' }}</p>
                </div>
            </div>
        </div>

        <!-- 3. Handpick Permissions -->
        <div class="builder-section">
            <div class="section-header">
                <div class="flex-between">
                    <div>
                        <h3><i class="pi pi-sliders-h"></i> 3. Handpick Permissions</h3>
                        <span class="section-subtitle">
                            Fine-tune individual permissions. Add extra capabilities beyond your stitched roles or inspect granted access.
                        </span>
                    </div>
                    <div class="filter-actions">
                        <button pButton type="button" label="Select All in Category" icon="pi pi-check" size="small" [outlined]="true" (click)="selectAllInActiveModule()"></button>
                        <button pButton type="button" label="Clear Category" icon="pi pi-times" size="small" [outlined]="true" severity="secondary" (click)="clearAllInActiveModule()"></button>
                    </div>
                </div>
            </div>

            <!-- Toolbar & Module Pills -->
            <div class="permission-toolbar">
                <div class="search-box">
                    <i class="pi pi-search"></i>
                    <input pInputText [(ngModel)]="searchTerm" placeholder="Search by permission code, name, or action (e.g. petty-cash, release)..." />
                </div>
                <div class="view-filter-buttons">
                    <button pButton type="button" label="All ({{ allPermissions.length }})"
                            [outlined]="permissionFilter !== 'ALL'" size="small" (click)="permissionFilter = 'ALL'"></button>
                    <button pButton type="button" label="Selected ({{ selectedPermissionIds.size }})"
                            [outlined]="permissionFilter !== 'SELECTED'" size="small" (click)="permissionFilter = 'SELECTED'"></button>
                    <button pButton type="button" label="Stitched ({{ countFromStitchedRoles }})"
                            [outlined]="permissionFilter !== 'STITCHED'" size="small" severity="info" (click)="permissionFilter = 'STITCHED'"></button>
                    <button pButton type="button" label="Handpicked ({{ countHandpicked }})"
                            [outlined]="permissionFilter !== 'HANDPICKED'" size="small" severity="warn" (click)="permissionFilter = 'HANDPICKED'"></button>
                </div>
            </div>

            <!-- Module Navigation Tabs -->
            <div class="module-chips-scroll">
                <span *ngFor="let mod of modules"
                      class="module-chip"
                      [class.active]="activeModule === mod"
                      (click)="activeModule = mod">
                    {{ mod }}
                </span>
            </div>

            <!-- Permissions Checklist Grid -->
            <div class="permissions-list-scroll">
                <div *ngIf="filteredPermissions.length === 0" class="empty-permissions">
                    <i class="pi pi-info-circle text-4xl mb-2 text-secondary"></i>
                    <p>No permissions match your search or filter.</p>
                </div>

                <div *ngFor="let perm of filteredPermissions"
                     class="permission-row"
                     [class.row-selected]="isPermissionSelected(perm.permissionId)"
                     (click)="togglePermission(perm)">
                    <div class="perm-check">
                        <p-checkbox
                            [binary]="true"
                            [ngModel]="isPermissionSelected(perm.permissionId)"
                            (click)="$event.stopPropagation()"
                            (onChange)="togglePermission(perm)">
                        </p-checkbox>
                    </div>
                    <div class="perm-info">
                        <div class="perm-title-row">
                            <span class="perm-name">{{ perm.permissionName }}</span>
                            <span class="perm-code text-secondary"><code>{{ perm.permissionCode }}</code></span>
                        </div>
                        <div class="perm-desc text-secondary" *ngIf="perm.description">{{ perm.description }}</div>
                    </div>
                    <div class="perm-badge">
                        <p-tag *ngIf="isPermissionSelected(perm.permissionId) && getStitchedSourceRoleName(perm.permissionId)"
                               icon="pi pi-link"
                               [value]="'Stitched: ' + getStitchedSourceRoleName(perm.permissionId)"
                               severity="info">
                        </p-tag>
                        <p-tag *ngIf="isPermissionSelected(perm.permissionId) && !getStitchedSourceRoleName(perm.permissionId)"
                               icon="pi pi-plus"
                               value="Handpicked"
                               severity="warn">
                        </p-tag>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Sticky Footer Summary & Actions -->
    <ng-template pTemplate="footer">
        <div class="dialog-footer-summary">
            <div class="summary-pills">
                <span class="summary-item">
                    <strong class="text-primary">{{ selectedPermissionIds.size }}</strong> Total Effective Permissions
                </span>
                <span class="summary-sep">|</span>
                <span class="summary-sub">
                    <i class="pi pi-link text-info"></i> {{ countFromStitchedRoles }} from stitched roles
                </span>
                <span class="summary-sep">|</span>
                <span class="summary-sub">
                    <i class="pi pi-plus text-warn"></i> {{ countHandpicked }} handpicked additions
                </span>
            </div>
            <div class="footer-buttons">
                <button pButton label="Cancel" severity="secondary" [outlined]="true" (click)="close(false)" [disabled]="isSaving"></button>
                <button pButton label="Save Custom Role" icon="pi pi-check" (click)="onSave()" [loading]="isSaving"></button>
            </div>
        </div>
    </ng-template>
</p-dialog>

